import { Headline, Layout, Text, TextButton } from '@oneaudi/unified-web-alpha-components';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { Dialog } from '~/components/dialog/dialog';
import { RenderHtml } from '~/components/text';
import { state } from '~/storage';

type MessageDialogData = {
	title: string;
	message: string;
};

export function useMessageDialog() {
	const [messageDialog, setMessageDialog] = useAtom(state.messageDialog);

	return {
		data: messageDialog,
		showMessageDialog: useCallback(
			(data: MessageDialogData) => {
				setMessageDialog(data);
			},
			[setMessageDialog],
		),
		open: !!messageDialog,
		close: useCallback(() => {
			setMessageDialog(null);
		}, [setMessageDialog]),
	};
}

export function MessageDialog() {
	const { open, close, data } = useMessageDialog();

	return (
		<Dialog open={open} onCloseButtonClick={close}>
			{data && <MessageDialogContent data={data} onClose={close} />}
		</Dialog>
	);
}

function MessageDialogContent({ data, onClose }: { data: MessageDialogData; onClose: () => void }) {
	const { i18n } = useI18n();

	return (
		<Layout direction="column" rowGap="32px">
			<Layout direction="column" rowGap="16px">
				<Headline tag={'h2'} variant={{ type: 'headline', order: '3', weight: 'bold' }}>
					{data.title}
				</Headline>
				<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>
					<RenderHtml html={data.message} />
				</Text>
			</Layout>
			<div>
				<TextButton variant="primary" onClick={onClose}>
					{i18n('ngc.actions.close')}
				</TextButton>
			</div>
		</Layout>
	);
}
